var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRXlsSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#FFF0F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E52333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11H13.25V29H26.75V15.5L22.25 11Z",
    fill: "#F4F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11V15.5H26.75L22.25 11Z",
    fill: "#D8E5DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11H13.25V29H26.75V15.5L22.25 11Z",
    stroke: "#262626",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 19.4525H21.5V25.7975H10.625V19.4525Z",
    fill: "#3FD065"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 19.4525H21.5V25.7975H10.625V19.4525Z",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.375V15.5H26.375",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 21.29H13.2725L13.7975 22.145L14.3413 21.29H14.9863L14.1275 22.5687L15.0613 23.9675H14.375L13.775 23.0412L13.1788 23.9675H12.5188L13.4525 22.565L12.59 21.29Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8751 21.29V23.4725H17.1801V23.9675H15.2976V21.29H15.8751Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9713 23.3075C18.0023 23.3673 18.0458 23.4197 18.0988 23.4612C18.1574 23.5004 18.222 23.5296 18.2901 23.5475C18.364 23.5641 18.4394 23.5728 18.5151 23.5737H18.6838C18.7423 23.5642 18.7991 23.5465 18.8526 23.5212C18.9037 23.4966 18.9486 23.4607 18.9838 23.4162C19.0201 23.369 19.0386 23.3107 19.0363 23.2512C19.0378 23.2185 19.0322 23.1858 19.0199 23.1554C19.0076 23.125 18.9889 23.0975 18.9651 23.075C18.9133 23.0257 18.8521 22.9874 18.7851 22.9625C18.7021 22.9302 18.6169 22.9039 18.5301 22.8837L18.2413 22.8087C18.142 22.7837 18.0443 22.7524 17.9488 22.715C17.8574 22.6816 17.7715 22.6349 17.6938 22.5762C17.6111 22.5162 17.5447 22.4363 17.5008 22.3439C17.4569 22.2515 17.4369 22.1496 17.4426 22.0475C17.4366 21.917 17.4664 21.7873 17.5288 21.6725C17.5854 21.5761 17.6606 21.492 17.7501 21.425C17.848 21.3565 17.9571 21.3057 18.0726 21.275C18.1946 21.2408 18.3209 21.2244 18.4476 21.2262C18.5829 21.2251 18.7178 21.2415 18.8488 21.275C18.9726 21.3017 19.0899 21.3526 19.1938 21.425C19.2936 21.4953 19.3757 21.5877 19.4338 21.695C19.491 21.8117 19.5205 21.94 19.5201 22.07H18.9463C18.944 22.0011 18.9274 21.9334 18.8976 21.8712C18.87 21.8208 18.83 21.7782 18.7813 21.7475C18.731 21.7158 18.6749 21.6941 18.6163 21.6837C18.5502 21.6777 18.4837 21.6777 18.4176 21.6837C18.3703 21.6782 18.3224 21.6782 18.2751 21.6837C18.2296 21.6927 18.1862 21.7105 18.1476 21.7362C18.109 21.7605 18.0759 21.7924 18.0501 21.83C18.0232 21.8725 18.0101 21.9223 18.0126 21.9725C18.0113 22.0169 18.0217 22.0608 18.0426 22.1C18.0715 22.1409 18.112 22.1723 18.1588 22.19C18.2378 22.2238 18.3193 22.2514 18.4026 22.2725L18.8113 22.3775L19.0213 22.43C19.1137 22.4617 19.2018 22.5045 19.2838 22.5575C19.3742 22.6185 19.4508 22.6977 19.5088 22.79C19.579 22.902 19.6131 23.033 19.6063 23.165C19.6105 23.2827 19.5868 23.3997 19.5373 23.5065C19.4878 23.6134 19.4138 23.7071 19.3213 23.78C19.2181 23.8615 19.0995 23.9214 18.9726 23.9562C18.8166 24.0009 18.6549 24.0224 18.4926 24.02C18.3473 24.0196 18.2025 24.002 18.0613 23.9675C17.9268 23.9336 17.7996 23.8751 17.6863 23.795C17.5815 23.7163 17.4957 23.615 17.4351 23.4987C17.3686 23.3664 17.3376 23.2191 17.3451 23.0712H17.9151C17.9133 23.1535 17.9327 23.2349 17.9713 23.3075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRXlsSelected);
export default __webpack_public_path__ + "static/media/r-xls-selected.d62d6181b23bf123f2291d019c7842cb.svg";
export { ForwardRef as ReactComponent };